import { UseBaseMutationResult } from '@tanstack/react-query';
import { OpenModal } from '../../../../../react-commons/utils/modals/openModal';
import { formatIdentifier } from '../../../../../react-commons/utils/utilFunctions';
import { ResourceType } from '../../../resource/enumerations/ResourceType';
import { formatEnum } from '../../../resource/enumerations/utils/formatEnum';
import { DeleteMutateObject } from '../../../resource/resource-base/mutateObjects';
import { MutationValidationResource } from '../../../resource/resources/validation/mutationValidationResource';
import {
    DeleteUseCaseStandardAssociation,
} from '../../../resource/resources/artifacts/use_case/useCaseStandardAssociationResource';
import { useDeletionServiceActions } from '../../../resource/services/deletionService';

export function useDeleteResourceDialogFunction() {
    const deletionServiceActions = useDeletionServiceActions();
    const deleteAction = deletionServiceActions.useDeleteResource();

    const deleteResource = (
        id: string,
        name: string | undefined | null,
        resourceType: ResourceType,
        deleteFunction: UseBaseMutationResult<MutationValidationResource | null, unknown, DeleteMutateObject>,
        onSuccess?: () => void,
        onCancel?: () => void
    ) => {
        OpenModal.AlertModal(
            'Warning',
            `Are you sure you want to try and delete ${formatEnum(ResourceType, resourceType)}${name ? ` "${name}"` : ''}?`,
            () => {
                deleteFunction.mutateAsync({ id }).then((value) => {
                    if (value?.successful === true && onSuccess) {
                        onSuccess();
                    }
                });
            },
            onCancel
        );
    };

    const deleteResourceByPersistableType = (
        id: string,
        name: string | undefined | null,
        persistableType: string,
        onSuccess?: () => void
    ) => {
        OpenModal.AlertModal(
            'Warning',
            `Are you sure you want to try and delete ${formatIdentifier(persistableType)}${name ? ` "${name}"` : ''}?`,
            () => {
                deleteAction.mutateAsync({ id, persistableType }).then((value) => {
                    if (value?.successful === true && onSuccess) {
                        onSuccess();
                    }
                });
            }
        );
    };

    const deleteUseCaseStructureAssociationResource = (
        useCaseId: string,
        standardObjectId: string,
        name: string | undefined | null,
        deleteFunction: UseBaseMutationResult<MutationValidationResource | null, unknown, DeleteUseCaseStandardAssociation>,
        onSuccess?: () => void,
        onCancel?: () => void
    ) => {
        OpenModal.AlertModal(
            'Warning',
            `Are you sure you want to try and delete ${formatEnum(ResourceType, ResourceType.USE_CASE_STANDARD_ASSOCIATION)}${name ? ` "${name}"` : ''}?`,
            () => {
                deleteFunction.mutateAsync({ useCaseId, standardObjectId }).then((value) => {
                    if (value?.successful === true && onSuccess) {
                        onSuccess();
                    }
                });
            },
            onCancel
        );
    };

    return { deleteResource, deleteResourceByPersistableType, deleteUseCaseStructureAssociationResource };
}
